@for (node of nodes; track node) {
  <ul class="nav nav-sidebar">
    @if (node.isVisible) {
      <li>
        <menu-parent-node [node]="node" class="menu-node"></menu-parent-node>
        @if (node.children) {
          <ul class="nav nav-sidebar sub-menu" [ngClass]="{'expanded' : !node.isCollapsed }">
            @for (child of node.children; track child) {
              <li>
                @if (child.isVisible) {
                  <menu-child-node [node]="child" class="menu-node menu-child-node"></menu-child-node>
                }
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
}
